export const PlagIcon = (): JSX.Element => {
  return (
    <svg width="24" height="24" fill="none">
      <path
        d="M15.54 14.18c-1.83 0-3.32-1.49-3.32-3.32 0-1.83 1.49-3.32 3.32-3.32 1.83 0 3.32 1.49 3.32 3.32 0 1.83-1.49 3.32-3.32 3.32Zm0-5.01c-.93 0-1.69.76-1.69 1.69 0 .93.76 1.69 1.69 1.69.93 0 1.69-.76 1.69-1.69 0-.93-.76-1.69-1.69-1.69Z"
        fill="#302C41"
      />
      <path
        d="M18.45 21.1h-5.82c-.79 0-1.44-.64-1.44-1.44v-1.14c0-2.4 1.95-4.35 4.35-4.35 2.4 0 4.35 1.95 4.35 4.35v1.14c0 .79-.64 1.44-1.44 1.44Zm-5.64-1.62h5.44v-.95c0-1.5-1.22-2.72-2.72-2.72-1.5 0-2.72 1.22-2.72 2.72v.95ZM9.23 18.7H5.31c-.66 0-1.2-.54-1.2-1.21V4.11c0-.67.54-1.21 1.2-1.21h9.83c.66 0 1.2.54 1.2 1.21v2.38c0 .45-.36.81-.81.81-.45 0-.81-.36-.81-.81V4.53H5.73v12.55h3.5c.45 0 .81.36.81.81 0 .45-.36.81-.81.81Z"
        fill="#302C41"
      />
      <path
        d="M12.444 7.3h-5.14c-.45 0-.81-.36-.81-.81 0-.45.36-.81.81-.81h5.14c.45 0 .81.36.81.81 0 .45-.36.81-.81.81ZM10.484 11.22h-3.18c-.45 0-.81-.36-.81-.81 0-.45.36-.81.81-.81h3.18c.45 0 .81.36.81.81 0 .45-.36.81-.81.81ZM10.874 15.14h-3.57c-.45 0-.81-.36-.81-.81 0-.45.36-.81.81-.81h3.57c.45 0 .81.36.81.81 0 .45-.36.81-.81.81Z"
        fill="#302C41"
      />
    </svg>
  )
}
